export const getAllEntries = (state) => {
  return state.gallery.entryIds.map((id) => state.gallery.entryById[id]);
};

export const getEntryById = (state, id) => {
  return state.gallery.entryById[id];
};

export const hasFetchedGalleryData = (state) => {
  return state.gallery.hasFetched;
};

export const isFetchingGalleryData = (state) => {
  return state.gallery.isFetching;
};

export const getDisplayEntry = (state) => {
  return state.gallery.displayEntry;
};

export const getCarouselEntries = (state) => {
  // select latest 6 entries for carousel
  const latestEntryIds = state.gallery.entryIds.slice(-6);
  return latestEntryIds.map((id) => state.gallery.entryById[id]);
};

export const getGallerySubmissionStatus = (state) => {
  return { status: state.gallery.submissionStatus, message: state.gallery.submissionMessage };
};

export const getGallerySubmissionFetching = (state) => {
  return state.gallery.isSubmitting;
};
